import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Stakes } from '../components/Stakes';
import { ProductLoop } from '../components/ProductLoop';
import { CreatorLab } from '../components/CreatorLab';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-navy-950 text-slate-300 font-sans selection:bg-electric selection:text-white" data-id="element-202">
      <Navbar data-id="element-203" />
      <main data-id="element-204">
        <Hero data-id="element-205" />
        <Stakes data-id="element-206" />
        <ProductLoop data-id="element-207" />
        <CreatorLab data-id="element-208" />
      </main>
      <Footer data-id="element-209" />
    </div>;
}